import { MaskLine, Reveal } from "../components/Reveal";

export default function PageHead({ eyebrow, title, hindi, intro, testid = "page-head" }) {
    return (
        <section className="pb-14 pt-32 lg:pb-20 lg:pt-40" data-testid={testid}>
            <div className="container-x">
                <Reveal y={16}>
                    <p className="eyebrow">{eyebrow}</p>
                </Reveal>
                <h1 className="mt-5 font-display font-extrabold uppercase leading-[0.98] tracking-tight text-ink">
                    <MaskLine delay={0.08} className="text-4xl sm:text-6xl lg:text-7xl">
                        {title}
                    </MaskLine>
                    {hindi && (
                        <MaskLine
                            delay={0.2}
                            className="mt-3 font-hindi text-lg font-semibold normal-case tracking-normal text-steel sm:text-2xl"
                        >
                            {hindi}
                        </MaskLine>
                    )}
                </h1>
                {intro && (
                    <Reveal delay={0.3} y={20}>
                        <p className="mt-7 max-w-2xl text-base leading-relaxed text-steel sm:text-lg">
                            {intro}
                        </p>
                    </Reveal>
                )}
            </div>
        </section>
    );
}
